import type { StateCreator } from 'zustand'
import type { AppState, UserState } from '../types'

export type UserSlice = Pick<
  AppState,
  'user' | 'setPhone' | 'setAuthenticated' | 'setAccessToken' | 'resetUser'
>

const initialState: UserState = {
  phone: null,
  isAuthenticated: false,
  accessToken: null,
}

export const createUserSlice: StateCreator<
  AppState,
  [['zustand/devtools', never], ['zustand/persist', unknown]],
  [],
  UserSlice
> = (set) => ({
  user: initialState,

  setPhone: (phone) =>
    set(
      (state) => ({ user: { ...state.user, phone } }),
      undefined,
      'user/setPhone'
    ),

  setAuthenticated: (isAuthenticated) =>
    set(
      (state) => ({ user: { ...state.user, isAuthenticated } }),
      undefined,
      'user/setAuthenticated'
    ),



  setAccessToken: (accessToken) =>
    set(
      (state) => ({ user: { ...state.user, accessToken } }),
      undefined,
      'user/setAccessToken'
    ),

  resetUser: () =>
    set({ user: initialState }, undefined, 'user/reset'),
})
